export const getLoading = state => state.loading;
